<div class="container">
  <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="closeShowModal()">
    <span aria-hidden="true" class="visually-hidden">&times;</span>
  </button>
  <h3 class="text-center pt-3">Client Intake - <span>#{{clientIntakeId}}</span></h3>
  <div class="col-md-12" style="padding-bottom: 10px;">
      <button type="button" class="btn btn-primary btn-sm mt-2 mr-2" (click)="editClientIntake()" *ngIf='!clientIntake.matter_id && (!clientIntake.locked || canEdit)'>Edit Client Intake</button>
      <button type="button" class="btn btn-primary btn-sm mt-2 mr-2" (click)="createMatter({})" *ngIf='!clientIntake.matter_id && (!clientIntake.locked || canEdit)'>Create Matter</button>
      <button type="button" class="btn btn-warning btn-sm mt-2 mr-2" (click)="deleteClientIntake()" *ngIf='!clientIntake.matter_id && (!clientIntake.locked || canEdit)'>Delete Client Intake</button>
      <button type="button" class="btn btn-danger btn-sm mt-2 mr-2" (click)="deleteclientIntakePermanently()" *ngIf='!clientIntake.matter_id && user.isAdmin()'>Delete Permanently</button>
      <button type="button" class="btn btn-warning btn-sm mt-2 mr-2" (click)="unlockClientIntake()" *ngIf='!clientIntake.matter_id && clientIntake.locked && canEdit'>Unlock Client Intake</button>
  </div>
  <div class="col-md-12 mt-4" *ngIf="!clientIntake.not_ready_for_matter">
      <p class="bg-danger text-white" style="padding-left: 5px;padding-right: 5px;">
        Incomplete client contact
      </p>
  </div>

  <div class="col-md-12 mt-4" *ngIf="clientIntake.priority">
      <p class="bg-success-light text-white" style="padding-left: 5px;padding-right: 5px;">
        Priority client intake
      </p>
  </div>

  <div class="col-md-12 mt-4" *ngIf="clientIntake.locked">
      <p class="bg-warning" style="padding-left: 5px;padding-right: 5px;">
        This client intake is locked
      </p>
  </div>

  <div class="col-md-12">
      <table class="table">
          <tbody>
              <tr>
                  <th style="text-align: left;font-weight: bold;">Matter</th>
                  <td>
                    <a class="btn btn-link" [routerLink]="'/matters/' + clientIntake.matter_id" *ngIf="clientIntake.matter_id">{{clientIntake.matter_number}}</a>
                    <span *ngIf="clientIntake.matter_id">{{clientIntake.matter_name}}</span>
                    <span *ngIf="!clientIntake.matter_id">No Matter defined</span>
                  </td>
              </tr>
              <tr *ngIf="clientIntake.matter_id">
                  <th style="text-align: left;font-weight: bold;">Matter Created By</th>
                  <td>
                    <span>{{clientIntake.matter_created_by_name}}</span>
                    <strong>&nbsp;on&nbsp;</strong>
                    <span>{{clientIntake.matter_created_at}}</span>
                  </td>
              </tr>
              <tr>
                  <th style="text-align: left;font-weight: bold;">Matter Type</th>
                  <td>{{clientIntake.matter_type_name}}</td>
              </tr>
              <tr>
                  <th style="text-align: left;font-weight: bold;">Client Name</th>
                  <td>{{clientIntake.client_name}}</td>
              </tr>
              <tr>
                  <th style="text-align: left;font-weight: bold;">Client Contact</th>
                  <td *ngIf="clientIntake.client_contact_id"><a class="btn btn-link p-0" [routerLink]="'/contacts/' + clientIntake.client_contact_id">{{clientIntake.client_contact_name}}</a></td>
                  <td class="text-danger" *ngIf="!clientIntake.client_contact_id">No Client Contact selected</td>
              </tr>
              <tr>
                  <th style="text-align: left;font-weight: bold;">Referral Type</th>
                  <td>{{clientIntake.referral_type_name}}</td>
              </tr>
              <tr>
                  <th style="text-align: left;font-weight: bold;">Referral Person</th>
                  <td >{{clientIntake.referral_person_name}}</td>
              </tr>
              <tr>
                  <th style="text-align: left;font-weight: bold;">Referral Percentage</th>
                  <td *ngIf="clientIntake.referral_percentage">{{clientIntake.referral_percentage}}</td>
                  <td *ngIf="!clientIntake.referral_percentage">No Referral Percentage</td>
              </tr>
              <tr>
                  <th style="text-align: left;font-weight: bold;">Rate Type</th>
                  <td >{{clientIntake.rate_type_name}}</td>
              </tr>
              <tr>
                  <th style="text-align: left;font-weight: bold;">Assigned to Attorney</th>
                  <td *ngIf="clientIntake.attorney_id">{{clientIntake.attorney_name}}</td>
                  <td *ngIf="!clientIntake.attorney_id">No attorney</td>
              </tr>
              <tr>
                  <th style="text-align: left;font-weight: bold;">Opener Attorney</th>
                  <td *ngIf="clientIntake.opener_id">{{clientIntake.opener_name}}</td>
                  <td *ngIf="!clientIntake.opener_id">No attorney</td>
              </tr>
              <tr>
                  <th style="text-align: left;font-weight: bold;">Parent Matter</th>
                  <td *ngIf="clientIntake.parent_matter_id">
                    <a class="btn btn-link"  [routerLink]="'/matters/' + clientIntake.parent_matter_id">{{clientIntake.parent_matter_number}}
                    </a><span>{{clientIntake.parent_matter_name}}</span>
                  </td>
                  <td *ngIf="!clientIntake.parent_matter_id">No Parent Matter</td>
              </tr>
              <tr>
                  <th style="text-align: left;font-weight: bold;">Default Appointment Address</th>
                  <td *ngIf="clientIntake.default_appointment_address_id">{{clientIntake.default_appointment_address_simple_address}}</td>
                  <td *ngIf="!clientIntake.default_appointment_address_id">No default appointment address</td>
              </tr>
              <tr *ngIf="clientIntake.appointment_scheduled_notes">
                  <th style="text-align: left;font-weight: bold;">New Client Appointment</th>
                  <td>
                    <div class="appointment_scheduled_at" style="font-weight: bold;">
                      Appointment Scheduled at:&nbsp;&nbsp;
                      <span  style="font-style:italic;">{{clientIntake.appointment_scheduled_at}}</span>
                    </div>
                    <div class="appointment_notes" >{{clientIntake.appointment_scheduled_notes}}</div>
                  </td>
              </tr>
              <tr *ngIf="clientIntake.created_by">
                  <th style="text-align: left;font-weight: bold;">Created by</th>
                  <td>
                    <span>{{clientIntake.created_by_name}}</span>
                    <strong>&nbsp;on &nbsp;</strong>
                    <span>{{clientIntake.created_at}}</span>
                  </td>
              </tr>
              <tr *ngIf="clientIntake.updated_by">
                  <th style="text-align: left;font-weight: bold;">Updated by</th>
                  <td>
                    <span>{{clientIntake.updated_by_name}}</span>
                    <strong>&nbsp;on &nbsp;</strong>
                    <span>{{clientIntake.updated_at}}</span>
                  </td>
              </tr>
              <tr>
                  <th style="text-align: left;font-weight: bold;">Tags</th>
                  <td >{{clientIntake.tag_list}}</td>
              </tr>
              <tr *ngIf="clientIntake.court_appointed || clientIntake.pro_bono">
                  <th style="text-align: left;font-weight: bold;">
                  </th>
                  <td>
                    <span class="label label-info" *ngIf="clientIntake.court_appointed">Court appointed</span>
                    <span *ngIf="clientIntake.court_appointed &amp;&amp; clientIntake.pro_bono">
                      &nbsp;
                    </span><span class="label label-info" *ngIf="clientIntake.pro_bono">Pro bono</span>
                  </td>
              </tr>
          </tbody>
      </table>
      <div class="card" *ngIf="clientIntake.notice">
          <div class="card-body">
            <h5 class="card-title">Notice</h5>
            <p class="card-text">{{clientIntake.notice}}</p>
          </div>
      </div>
      <div class="card" *ngIf="clientIntake.notes">
          <div class="card-body">
            <h5 class="card-title">Notes</h5>
            <p class="card-text">{{clientIntake.notes}}</p>
          </div>
      </div>
      <div class="card" *ngIf="clientIntake.history">
          <div class="card-body">
            <h5 class="card-title">History</h5>
            <p class="card-text">{{clientIntake.history}}</p>
          </div>
      </div>
      <div class="row" *ngFor="let clientIntakeField of clientIntakeFields">
          <div class="col-md-12" style="border-bottom: 1px solid #ccc;">
            <div class="form-group">
              <label [innerHTML]="clientIntakeField.prompt | safeHtml"
              data-placement="right"
              data-toggle="tooltip"
              [class]="{'text-primary': (clientIntakeField.is_header)}"
              [title]="clientIntakeField.description"
              [style]="{'font-size': (clientIntakeField.is_header ? '130%' : '')}">
              </label>
              <div class="bg-primary-light" *ngIf="!clientIntakeField.field_type_obj.multiple" [style]="{'padding-left': (clientIntakeField.client_intake_field_values ? '10px' : '0px')}">
                <div *ngFor="let client_intake_field_value of clientIntakeField.client_intake_field_values" class="text-white">
                  <span *ngIf="!clientIntakeField.field_type_obj.field_linked && clientIntakeField.client_intake_field_values">
                    {{client_intake_field_value.name}}
                  </span>
                  <span *ngIf="clientIntakeField.field_type_obj.field_linked">
                    {{client_intake_field_value.name || client_intake_field_value.value}}
                  </span>
                </div>
              </div>
              <div *ngIf="clientIntakeField.field_type_obj.multiple">
                <div *ngFor="let clientIntakeFieldValue of clientIntakeField.client_intake_field_values">
                  <p [class]="{'bg-success-light': clientIntakeField.field_type_obj.data_type == 'text', 'bg-info-light': clientIntakeField.field_type_obj.field_linked == 'Contact', 'bg-warning-light': clientIntakeField.field_type_obj.data_type == 'date'}">
                    <a class="btn btn-link" [href]="'/contacts/' + clientIntakeFieldValue.value" *ngIf="clientIntakeFieldValue.name" target="_blank">
                      {{clientIntakeFieldValue.name}}
                    </a>
                    <span *ngIf="!clientIntakeFieldValue.name" style="margin-left: 10px;">
                      {{clientIntakeFieldValue.value}}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
      </div>
  </div>
</div>